import React, { useRef, useState } from "react";
import { Button, ConfigProvider, Descriptions, Input } from "antd";
import style from "css/modal.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  openConfirm,
  closeAlert,
  openAlert,
} from "../../redux/slices/alertSlice";
import { useMediaQuery } from "react-responsive";
import axios from "axios";

function ApplyLicense(props) {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 769px) and (max-width: 1023px)",
  });
  //dispatch
  const dispatch = useDispatch();

  //payload
  const userPayload = useSelector((state) => state.user);

  const descriptionItem = [
    {
      key: 1,
      label: "학번/교번",
      children: userPayload.userId,
      span: "filled",
    },
    { key: 2, label: "이름", children: userPayload.userNm, span: "filled" },
  ];

  const periodIdRef = useRef(null);

  const [isEdit, setIsEdit] = useState(false);
  const [userId, setUserId] = useState(userPayload.email);

  const applicationLicense = () => {
    // 1. 요청 데이터 준비
    const data = {
      PERIOD_ID: props.product.PERIOD_ID,
      LICENSE_ID: props.product.LICENSE_ID,
      EMAIL: userId,
    };

    axios
      .post("/license/apply", data)
      .then((res) => {
        // [수정] 대기열 시스템 연동 로직
        const resData = res.data;

        // Case 1: 대기열 번호표를 받은 경우 (HTTP 202 or ticketNumber 존재)
        if (res.status === 202 || resData.ticketNumber) {
          props.setStatus("queue", {
            number: resData.ticketNumber,
            userId: userPayload.userId,
          });
        }
        // Case 2: 대기열 없이 바로 성공한 경우 (기존 로직 호환)
        else if ((res.status === 200 || res.status === 201) && resData.result) {
          props.setStatus("complete");
          setUserId(userPayload.email);
        }
        // Case 3: 실패
        else {
          const msg = resData.msg || resData.message || "신청에 실패했습니다.";
          const obj = {
            title: "알림",
            content: msg,
            submitEventHandler: () => {
              // 실패 시 모달을 닫을지, 입력창에 머물지 결정 (여기선 닫음)
              props.close();
              dispatch(closeAlert());
            },
          };
          dispatch(openAlert(obj));
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg =
          err.response?.data?.message || err.response?.data || "서버 통신 오류";

        const obj = {
          title: "오류",
          content: errMsg,
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      });
  };

  return (
    <div className={style.license_modal}>
      <div className={style.modal_title_wrapper}>
        <span className={style.modal_title}>
          {props.product.PRODUCT_NM + " 라이선스 신청"}
        </span>
        <span className={style.modal_subtitle}>
          본 서비스는 연세포털 계정을 연동하여 제공합니다.
        </span>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Descriptions: {
              fontSize: isMobile || isTablet ? 14 : 16,
              fontFamily: "Pretendard",
              labelBg: "#527ff2",
              colorTextSecondary: "#ffffff",
              colorSplit: "#bdc0c5",
            },
          },
        }}
      >
        <Descriptions
          bordered
          size="small"
          items={descriptionItem}
          classNames={{
            label: style.description_label,
          }}
        />
      </ConfigProvider>
      <div className={style.liecnese_id_wrap}>
        <div className={style.license_id_box_outer}>
          <article className={style.license_description}>
            <div className={style.license_description_title}>
              <img src="/img/common/info-icon-black.png" alt="" />
              <p>
                <strong>안내사항</strong>
              </p>
            </div>
            <p>
              <strong>사용하실 계정을 확인</strong>해 주시기 바랍니다.
            </p>
            <p>
              변경이 필요하신 경우 수정 버튼을 클릭하여 변경해 주시기 바랍니다.
            </p>
          </article>

          <div className={style.license_id_box_inner}>
            <img
              alt="product"
              src={`${process.env.REACT_APP_CLIENT_URL}img/product/adobe/${props.product.IMG_NM}`}
              style={{ width: isMobile || isTablet ? "40px" : "50px" }}
            />
            {isEdit ? (
              <>
                <Input
                  className={`${style.license_application_id_input}`}
                  type={"text"}
                  ref={periodIdRef}
                  placeholder="사용하실 계정을 입력해 주세요."
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                  onPressEnter={() => setIsEdit(!isEdit)}
                />
                <ConfigProvider
                  theme={{
                    components: {
                      Button: {
                        fontFamily: "Pretendard",
                        defaultBorderColor: "#527ff2",
                      },
                    },
                  }}
                >
                  <Button
                    className={`${style.license_application_id_edit_btn} ${style.active}`}
                    onClick={() => setIsEdit(!isEdit)}
                  >
                    확인
                  </Button>
                </ConfigProvider>
              </>
            ) : (
              <>
                <div className={style.license_application_id}>
                  {isMobile || isTablet ? (
                    <>
                      <div>{`${props.product.PRODUCT_NM} 계정`}</div>
                      <span>{userId}</span>
                    </>
                  ) : (
                    <>
                      <div>{`${props.product.PRODUCT_NM} 계정:`}</div>
                      <span>{userId}</span>
                    </>
                  )}
                </div>
                <ConfigProvider
                  theme={{
                    components: {
                      Button: {
                        fontFamily: "Pretendard",
                        defaultHoverBorderColor: "#527ff2",
                        defaultHoverColor: "#527ff2",
                      },
                    },
                  }}
                >
                  <Button
                    className={style.license_application_id_edit_btn}
                    onClick={() => setIsEdit(!isEdit)}
                  >
                    수정
                  </Button>
                </ConfigProvider>
              </>
            )}
          </div>
        </div>
      </div>

      <div className={style.modal_footer}>
        <ConfigProvider
          theme={{
            components: {
              Button: {
                fontFamily: "Pretendard",
                colorPrimaryHover: "#527ff2",
                colorPrimaryActive: "#527ff2",
              },
            },
          }}
        >
          <Button
            type="primary"
            className={style.modal_submit_btn}
            onClick={() => {
              const obj = {
                title: "알림",
                content: "라이선스를 신청하시겠습니까?",
                submitEventHandler: () => {
                  applicationLicense();
                  dispatch(closeAlert());
                },
              };
              dispatch(openConfirm(obj));
            }}
          >
            신청하기
          </Button>
        </ConfigProvider>
      </div>
    </div>
  );
}

export default ApplyLicense;
